import { HORIZONTAL_ASPECTS_STRING } from '@anm/data/aspects';
import { SQUARE_ASPECTS_STRING } from '@anm/data/aspects';
import { FACEBOOK_COVER_ASPECT } from '@anm/data/aspects';

import { TemplatePage } from './types';

const imagePage: TemplatePage = {
  header: {
    color: '#FDB7AF',
    icon: 'images/video-templates/trending.jpg',
    title: 'Free Image Templates',
    title_meta: 'Free Editable Image Templates',
    description_meta:
      'Easily create appealing designs with Wave.video’s ready-made editable image templates. ' +
      'Make thumbnails, overlays, social media graphics, and more to amaze your online audience.',
    description:
      'Easily create appealing designs with our ready-made editable image templates. ' +
      'Make thumbnails, overlays, social media graphics, and more to increase engagement and amaze your online audience.'
  },
  footer: {
    type: 'image',
    showCustomizeVideo: false,
    category: '',
    description:
      'With extensive collection of easy-to-edit and free image templates, you will be able to create memorable ' +
      'images for social media, emails, live streams, and more effortlessly. No need to clutter up your computer with heavy ' +
      'software and files — you will only need access to the internet and a web browser to succeed in all of your creative ' +
      'endeavors. Just select a template that you prefer and effortlessly customize it to your taste. Save time on creating ' +
      'professional-looking thumbnails, lower thirds, memes, and more. Reach your marketing goals with Wave.video free image ' +
      'templates!'
  },
  content: [
    {
      type: 'slider',
      title: 'Thumbnail Templates',
      name: 'image-thumbnail',
      search: {
        category: '/images/thumbnail',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Lower Third Templates',
      name: 'image-lower-third',
      search: {
        category: '/images/lower third',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Meme Templates',
      name: 'image-meme',
      search: {
        category: '/images/meme',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Facebook Cover Templates',
      name: 'image-facebook-cover',
      search: {
        category: '/images/facebook cover',
        aspects: FACEBOOK_COVER_ASPECT
      }
    },
    {
      type: 'slider',
      title: 'Quote Templates',
      name: 'image-quote',
      search: {
        category: '/images/quote',
        aspects: SQUARE_ASPECTS_STRING
      }
    }
  ]
};

export default imagePage;
